<template>
  <div id="confirm">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'confirm'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhibitor/Confirm.vue